/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Groups_CountInputs */

const en_groups_count = /** @type {(inputs: Groups_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} groups`)
};

const es_groups_count = /** @type {(inputs: Groups_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} grupos`)
};

const fr_groups_count = /** @type {(inputs: Groups_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} groupes`)
};

const de_groups_count = /** @type {(inputs: Groups_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Gruppen`)
};

const id_groups_count = /** @type {(inputs: Groups_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} grup`)
};

/** @type {(inputs: Groups_CountInputs) => LocalizedString} */
const ja_groups_count = en_groups_count;

/** @type {(inputs: Groups_CountInputs) => LocalizedString} */
const zh_groups_count = en_groups_count;

/** @type {(inputs: Groups_CountInputs) => LocalizedString} */
const ar_groups_count = en_groups_count;

/** @type {(inputs: Groups_CountInputs) => LocalizedString} */
const it_groups_count = en_groups_count;

/** @type {(inputs: Groups_CountInputs) => LocalizedString} */
const ru_groups_count = en_groups_count;

/** @type {(inputs: Groups_CountInputs) => LocalizedString} */
const pt_groups_count = en_groups_count;

/** @type {(inputs: Groups_CountInputs) => LocalizedString} */
const ko_groups_count = en_groups_count;

/**
* | output |
* | --- |
* | "{count} groups" |
*
* @param {Groups_CountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const groups_count = /** @type {((inputs: Groups_CountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groups_CountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groups_count(inputs)
	if (locale === "es") return es_groups_count(inputs)
	if (locale === "fr") return fr_groups_count(inputs)
	if (locale === "de") return de_groups_count(inputs)
	if (locale === "ja") return ja_groups_count(inputs)
	if (locale === "zh") return zh_groups_count(inputs)
	if (locale === "ar") return ar_groups_count(inputs)
	if (locale === "id") return id_groups_count(inputs)
	if (locale === "it") return it_groups_count(inputs)
	if (locale === "ru") return ru_groups_count(inputs)
	if (locale === "pt") return pt_groups_count(inputs)
	return ko_groups_count(inputs)
});